// extracted by mini-css-extract-plugin
module.exports = {"acsmTargetStyle":"_1YwS_e83inZrsk3mUYUO8B"};